// extracted by mini-css-extract-plugin
module.exports = {"container":"progress-percentage_container__p-6p8","progress-container":"progress-percentage_progress-container__11X3V","progress":"progress-percentage_progress__2qXOX"};